import React from 'react'
import type {PocketItem} from '@dv5/domain'
import './PocketListItem.less'

interface PocketListItemProps {
    item: PocketItem
    index: number
    active: boolean
    onSelect: (index: number) => void
}

export const PocketListItem: React.FC<PocketListItemProps> = ({
                                                                  item,
                                                                  index,
                                                                  active,
                                                                  onSelect,
                                                              }) => {
    const selectItem = (event: React.MouseEvent<HTMLLIElement>) => {
        event.stopPropagation()
        event.preventDefault()
        onSelect(index)
    }

    return (
        <li className={"pocket-list-item" + (active ? " selected" : "")} onMouseDown={selectItem}>
            <span className="pocket-list-item-source">
                {item.source || item.sourceId}
            </span>
            <span className="pocket-list-item-id">
                {item.title || item.id}
            </span>
        </li>
    )
}
